// CSV building shared by the Journeys and Reports pages.
//
// Pure (no imports, no DOM) so the root vitest suite can load it. The browser
// download itself lives in lib/download-file.ts.

/** One CSV cell: quoted when needed (RFC 4180), and neutralised if a
 *  spreadsheet would read it as a formula. Anything a client or the AI wrote
 *  (summaries, names, subjects) can start with = + - @ — Excel/Sheets would run
 *  it — so those get a leading apostrophe. */
export function csvCell(value: unknown): string {
  let s = value === null || value === undefined ? '' : String(value);
  if (typeof value !== 'number' && /^[=+\-@\t\r]/.test(s)) s = `'${s}`;
  return /[",\r\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

/** Excel-friendly CSV: UTF-8 BOM first, CRLF line endings, trailing newline. */
export function toCsv(header: string[], rows: unknown[][]): string {
  const lines = [header.map(csvCell).join(',')];
  for (const r of rows) lines.push(r.map(csvCell).join(','));
  return '﻿' + lines.join('\r\n') + '\r\n';
}
